import { LayoutRegistryType } from '@website-builder/model/structure/layout-registry/layout-registry-type';

export class LayoutRegistry {
  static readonly availableLayouts: LayoutRegistryType[] = [
    { description: 'Whole', layout: [1], icon: 'whole', classes: ['uk-width-1-1'] },
    { description: 'Halves', layout: [1, 1], icon: 'halves', classes: ['uk-width-1-2@m', 'uk-width-1-2@m'] },
    {
      description: 'Thirds',
      layout: [1, 1, 1],
      icon: 'thirds',
      classes: ['uk-width-1-3@m', 'uk-width-1-3@m', 'uk-width-1-3@m'],
    },
    {
      description: 'Quarters',
      layout: [1, 1, 1, 1],
      icon: 'quarters',
      classes: [
        'uk-width-1-4@m uk-width-1-2@s',
        'uk-width-1-4@m uk-width-1-2@s',
        'uk-width-1-4@m uk-width-1-2@s',
        'uk-width-1-4@m uk-width-1-2@s',
      ],
    },
    {
      description: 'Fifths',
      layout: [1, 1, 1, 1, 1],
      icon: 'fifths',
      classes: [
        'uk-width-1-5@m uk-width-1-2@s',
        'uk-width-1-5@m uk-width-1-2@s',
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-1-5@m uk-width-1-3@s',
      ],
    },
    { description: 'Thirds 2-1', layout: [2, 1], icon: 'thirds-2-1', classes: ['uk-width-2-3@m', 'uk-width-1-3@m'] },
    { description: 'Thirds 1-2', layout: [1, 2], icon: 'thirds-1-2', classes: ['uk-width-1-3@m', 'uk-width-2-3@m'] },
    {
      description: 'Quarters 3-1',
      layout: [3, 1],
      icon: 'quarters-3-1',
      classes: ['uk-width-3-4@m', 'uk-width-1-4@m'],
    },
    {
      description: 'Quarters 1-3',
      layout: [1, 3],
      icon: 'quarters-1-3',
      classes: ['uk-width-1-4@m', 'uk-width-3-4@m'],
    },
    {
      description: 'Quarters 2-1-1',
      layout: [2, 1, 1],
      icon: 'quarters-2-1-1',
      classes: ['uk-width-1-2@m uk-width-1-1@s', 'uk-width-1-4@m uk-width-1-2@s', 'uk-width-1-4@m uk-width-1-2@s'],
    },
    {
      description: 'Quarters 1-1-2',
      layout: [1, 1, 2],
      icon: 'quarters-1-1-2',
      classes: ['uk-width-1-4@m uk-width-1-2@s', 'uk-width-1-4@m uk-width-1-2@s', 'uk-width-1-2@m uk-width-1-1@s'],
    },
    {
      description: 'Quarters 1-2-1',
      layout: [1, 2, 1],
      icon: 'quarters-1-2-1',
      classes: ['uk-width-1-4@m', 'uk-width-1-2@m', 'uk-width-1-4@m'],
    },
    { description: 'Fifths 2-3', layout: [2, 3], icon: 'fifths-2-3', classes: ['uk-width-2-5@m', 'uk-width-3-5@m'] },
    { description: 'Fifths 3-2', layout: [3, 2], icon: 'fifths-3-2', classes: ['uk-width-3-5@m', 'uk-width-2-5@m'] },
    { description: 'Fifths 1-4', layout: [1, 4], icon: 'fifths-1-4', classes: ['uk-width-1-5@m', 'uk-width-4-5@m'] },
    { description: 'Fifths 4-1', layout: [4, 1], icon: 'fifths-4-1', classes: ['uk-width-4-5@m', 'uk-width-1-5@m'] },
    {
      description: 'Fifths 3-1-1',
      layout: [3, 1, 1],
      icon: 'fifths-3-1-1',
      classes: ['uk-width-3-5@m uk-width-1-1@s', 'uk-width-1-5@m uk-width-1-2@s', 'uk-width-1-5@m uk-width-1-2@s'],
    },
    {
      description: 'Fifths 1-1-3',
      layout: [1, 1, 3],
      icon: 'fifths-1-1-3',
      classes: ['uk-width-1-5@m uk-width-1-2@s', 'uk-width-1-5@m uk-width-1-2@s', 'uk-width-3-5@m uk-width-1-1@s'],
    },
    {
      description: 'Fifths 1-3-1',
      layout: [1, 3, 1],
      icon: 'fifths-1-3-1',
      classes: ['uk-width-1-5@m', 'uk-width-3-5@m', 'uk-width-1-5@m'],
    },
    {
      description: 'Fifths 2-1-1-1',
      layout: [2, 1, 1, 1],
      icon: 'fifths-2-1-1-1',
      classes: [
        'uk-width-2-5@m uk-width-1-1@s',
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-1-5@m uk-width-1-3@s',
      ],
    },
    {
      description: 'Fifths 1-1-1-2',
      layout: [1, 1, 1, 2],
      icon: 'fifths-1-1-1-2',
      classes: [
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-1-5@m uk-width-1-3@s',
        'uk-width-2-5@m uk-width-1-1@s',
      ],
    },
    { description: 'Fixed-Left', layout: [-1, 1], icon: 'fixed-left', classes: ['uk-width-1-4', 'uk-width-3-4'] },
    { description: 'Fixed-Right', layout: [1, -1], icon: 'fixed-right', classes: ['uk-width-3-4', 'uk-width-1-4'] },
    {
      description: 'Fixed-Inner',
      layout: [1, -1, 1],
      icon: 'fixed-inner',
      classes: ['uk-width-1-3', 'uk-width-1-3', 'uk-width-1-3'],
    },
    {
      description: 'Fixed-Outer',
      layout: [-1, 1, -1],
      icon: 'fixed-outer',
      classes: ['uk-width-1-4', 'uk-width-1-2', 'uk-width-1-4'],
    },
  ];

  static getToolboxLayout(layout: number[]): LayoutRegistryType {
    return this.availableLayouts.find(elem => elem.layout.toString() === layout.toString());
  }

  static getAllLayouts(): LayoutRegistryType[] {
    return this.availableLayouts;
  }

  static getWebsiteLayout(paramLayout: number[]): LayoutRegistryType {
    const layout = { ...this.availableLayouts.find(elem => elem.layout.toString() === paramLayout.toString()) };

    /* on fixed type layouts, for website preview, classes are different than the ones on builder-toolbox */
    if (layout.description.includes('Fixed')) {
      const classes = layout.layout.map(columnLayout => (columnLayout === -1 ? 'uk-width-large@s' : 'uk-width-expand@s'));

      return { classes: classes };
    }

    return layout;
  }
}
